import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'expandIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#387DFF",
  },
  width: {
    type: Number as PropType<number>,
    default: 18,
  },
  height: {
    type: Number as PropType<number>,
    default: 18,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M1.5 16.11H10a0.25 0.25 0 0 1 0.25 0.25v2a0.25 0.25 0 0 1 -0.25 0.25H8.66a1 1 0 0 0 -0.92 0.61A1 1 0 0 0 8 20.34l2.87 2.87a1 1 0 0 0 0.7 0.29 1 1 0 0 0 0.71 -0.29l2.86 -2.87a1 1 0 0 0 -0.7 -1.7H13a0.25 0.25 0 0 1 -0.25 -0.25v-2a0.25 0.25 0 0 1 0.25 -0.25h9.5a1.25 1.25 0 0 0 0 -2.5h-21a1.25 1.25 0 0 0 0 2.5Z",
        "stroke-width": "1",
        fill: __props.color
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M0.25 10.09a1.25 1.25 0 0 0 1.25 1.25h21a1.25 1.25 0 0 0 0 -2.5H13a0.25 0.25 0 0 1 -0.25 -0.25v-3a0.25 0.25 0 0 1 0.25 -0.23h1.37a1 1 0 0 0 0.7 -1.7L12.23 0.79a1 1 0 0 0 -1.41 0L8 3.66a1 1 0 0 0 -0.21 1.09 1 1 0 0 0 0.92 0.61H10a0.25 0.25 0 0 1 0.25 0.25v3a0.25 0.25 0 0 1 -0.25 0.25H1.5a1.25 1.25 0 0 0 -1.25 1.23Z",
        "stroke-width": "1",
        fill: __props.color
      }, null, 8, _hoisted_3)
    ])
  ], 8, _hoisted_1))
}
}

})